import { render, staticRenderFns } from "./JSelectCenJi.vue?vue&type=template&id=502f83b2&scoped=true"
import script from "./JSelectCenJi.vue?vue&type=script&lang=js"
export * from "./JSelectCenJi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502f83b2",
  null
  
)

export default component.exports